import { useMutation, useQueryClient } from 'react-query';

import Api from '../../api/api';

export const disapproveSubCategory = async (subCategoryId: string) => {
  const [response, bodyOrError] = await Api.delete(`sub-categories/${subCategoryId}`);
  if (!response.ok) {
    throw bodyOrError;
  }
  return bodyOrError;
};

export const useDisapproveSubCategory = () => {
  const queryClient = useQueryClient();

  return useMutation(
    'disapproveSubCategory',
    (data: { subCategoryId: string }) => {
      return disapproveSubCategory(data.subCategoryId);
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries(['suggestedSubCategories']);
      },
    },
  );
};
